import { useState } from 'react';
import Footer from '../../components/feature/Footer';
import Modal from '../../components/base/Modal';
import ContactFormModal from '../../components/feature/ContactFormModal';
import WhatsAppButton from '../../components/base/WhatsAppButton';
import HeroSection from './components/HeroSection';
import TransformationSection from './components/TransformationSection';
import AuthoritySection from './components/AuthoritySection';
import MethodSection from './components/MethodSection';
import SolutionsSection from './components/SolutionsSection';
import TestimonialsSection from './components/TestimonialsSection';
import VideoTestimonialsSection from './components/VideoTestimonialsSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';

export default function Home() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [hasPartialData, setHasPartialData] = useState(false);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [hasCompletedAdditionalFields, setHasCompletedAdditionalFields] = useState(false);

  const openContactModal = () => setIsContactModalOpen(true);
  const openWhatsApp = () => {
    window.open('https://api.whatsapp.com/send?phone=5519992542649&text=Ol%C3%A1,%20vim%20do%20Google%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20curso%20em%20Campinas', '_blank');
  };
  const closeContactModal = () => {
    setIsContactModalOpen(false);
    // Reset estados ao fechar
    setTimeout(() => {
      setHasPartialData(false);
      setShowAdditionalFields(false);
      setHasCompletedAdditionalFields(false);
    }, 300);
  };

  return (
    <div className="min-h-screen">
      <main>
        <HeroSection onOpenModal={openWhatsApp} />
        <TransformationSection onOpenModal={openWhatsApp} />
        <AuthoritySection onOpenModal={openWhatsApp} />
        <MethodSection onOpenModal={openWhatsApp} />
        <SolutionsSection onOpenModal={openWhatsApp} />
        <TestimonialsSection onOpenModal={openWhatsApp} />
        <VideoTestimonialsSection onOpenModal={openWhatsApp} />
        <FAQSection onOpenModal={openWhatsApp} />
        <FinalCTASection onOpenModal={openContactModal} />
      </main>
      <Footer />
      
      {/* Botão flutuante do WhatsApp */}
      <WhatsAppButton onClick={openWhatsApp} />
      
      {/* Modal de contato */}
      <Modal 
        isOpen={isContactModalOpen} 
        onClose={closeContactModal}
        hasPartialData={hasPartialData}
        showAdditionalFields={showAdditionalFields}
        hasCompletedAdditionalFields={hasCompletedAdditionalFields}
      >
        <ContactFormModal 
          onSuccess={closeContactModal}
          onPartialDataChange={setHasPartialData}
          onAdditionalFieldsChange={setShowAdditionalFields}
          onCompletedAdditionalFieldsChange={setHasCompletedAdditionalFields}
        />
      </Modal>
    </div>
  );
}